import type { IconSvgObject } from './types';

const Invoice04Icon: IconSvgObject = [
  ["path", { d: "M4.5 21L5.8199 7.80099C5.92214 6.77859 6.78247 6 7.80998 6H16.19C17.2175 6 18.0779 6.77859 18.1801 7.80099L19.5 21L17 20L14.5 22L12 20L9.5 22L7 20L4.5 21Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 10H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 14H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 9.5C2 9.5 2 8.24028 2 7.5V4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V7.5C22 8.24028 22 9.5 21 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Invoice04Icon;
